export const LOAD_CHANGELOG = "LOAD_CHANGELOG";
export const CLEAR_CHANGELOG = "CLEAR_CHANGELOG";
export const LOAD_VALIDATION_MESSAGE = "LOAD_VALIDATION_MESSAGE";
export const LOAD_PUBLISH_HISTORY = "LOAD_PUBLISH_HISTORY";
export const DELETE_PUBLISH_HISTORY = "DELETE_PUBLISH_HISTORY";
